<template>
  <div class="flow-item">
    <div class="flow--header">
      <div class="flow--title-container">
        <h3 class="flow--title" @click="handleView(flow.instanceId)">
          {{ flow.title || '-' }}
        </h3>
      </div>
      <div
        class="flow--name-tag"
        :style="{
          backgroundColor: getTagColor(flow.index).bg,
          color: getTagColor(flow.index).text,
        }"
      >
        {{ flow.flowName || '-' }}
      </div>
    </div>

    <div class="flow--info">
      <div class="info-item flex-space-between">
        <div class="info-row">
          <span class="info-value">
            流水号：{{ flow.businessNumber || '-' }}
          </span>
        </div>
        <div class="info-row">
          <svg
            class="info-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8m.5-13H11v6l5.2 3.2.8-1.2-4.5-2.7V7z"
            ></path>
          </svg>
          <span class="info-value">{{ flow.startTime || '-' }}</span>
        </div>
        <div class="info-row">
          <svg
            class="info-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12 4A4 4 0 0 1 16 8A4 4 0 0 1 12 12A4 4 0 0 1 8 8A4 4 0 0 1 12 4M12 14C16.42 14 20 15.79 20 18V20H4V18C4 15.79 7.58 14 12 14Z"
            ></path>
          </svg>
          <span class="info-value">{{ flow.initiator || '-' }}</span>
        </div>
      </div>
    </div>
    <div class="flow--ai-summary" :title="flow.aiSummary || ''">
      {{ getTruncatedSummary(flow.aiSummary || '') }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FlowCard',
    props: {
      flow: {
        type: Object,
        default: () => ({}),
      },
    },
    methods: {
      handleView(instanceId) {
        const openUrl = `${window.context.front}/matter/approvalForm?instId=${instanceId}&type=fromMonitor`

        window.open(openUrl, '_blank')
      },

      getTruncatedSummary(summary) {
        if (!summary) return ''
        return summary
      },

      getTagColor(index) {
        const colorSchemes = [
          { bg: '#DBEAFE', text: '#1E40AF' },
          { bg: '#DCFCE7', text: '#166534' },
          { bg: '#F3E8FF', text: '#6B21A8' },
          { bg: '#FEF9C3', text: '#854D0E' },
          // { bg: '#E0E7FF', text: '#3831A3' },
        ]
        if (index === undefined || index === null) {
          return colorSchemes[0]
        }
        const colorIndex = index % colorSchemes.length
        return colorSchemes[colorIndex]
      },
    },
  }
</script>

<style lang="scss" scoped>
  .flow-item {
    position: relative;
    padding: 14px;
    margin-bottom: 8px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s, transform 0.2s;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      transform: translateY(-2px);
    }
  }

  .flow--header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .flow--title-container {
    flex: 1;
    margin-right: 12px;
  }

  .flow--title {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.6;
    color: #2563eb;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: #40a9ff;
      text-decoration: underline;
    }
  }

  .flow--name-tag {
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 400;
    white-space: nowrap;
    border-radius: 4px;
  }

  .flow--info {
    margin-bottom: 8px;
  }

  .info-item {
    font-size: 11px;
  }

  .flex-space-between {
    display: flex;
    align-items: center;
  }

  .info-row {
    display: flex;
    gap: 2px;
    align-items: center;
    margin-right: 20px;
  }

  .info-row:last-child {
    margin-right: 0;
  }

  .info-icon {
    color: #6b7280;
  }

  .info-value {
    color: #6b7280;
  }

  .flow--ai-summary {
    max-width: 80%;
    overflow: hidden;
    font-size: 12px;
    line-height: 1.5;
    color: #303133;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
